import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { triggersService } from '../services/triggers';

const key = ['triggers'] as const;

export function useTriggers() {
  return useQuery({ queryKey: key, queryFn: () => triggersService.list() });
}

export function useCreateTrigger() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (workflowId: string) => triggersService.create(workflowId),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}

export function useUpdateTrigger() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, enabled }: { id: string; enabled: boolean }) =>
      triggersService.setEnabled(id, enabled),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}

export function useRotateTrigger() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => triggersService.rotate(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}

export function useDeleteTrigger() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => triggersService.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: key }),
  });
}
